const notificationsTypesWithoutBtn = ['request', 'counterpartyLinkedProfile'];

export const showDetailsButton = (value: string) => {
  const check = notificationsTypesWithoutBtn.find((condition) => condition === value);
  if (check) {
    return true;
  } else {
    return false;
  }
};
